import type { IAction } from '../../action/IAction'
import type { PaymentRefund } from '../PaymentRefund'
import { Field, InputType, ObjectType } from 'type-graphql'
import { ActionArgs } from '../../action'
import type { PaymentStatusEnum } from '../PaymentStatusEnum'
import type { PaymentGatewayProvider } from '../PaymentGatewayProviderEnum'

@InputType()
@ObjectType()
export class RefundPaymentArgs extends ActionArgs {
  @Field(() => String)
  paymentId: string

  @Field(() => String)
  chargeId?: string

  @Field(() => String)
  reason: string

  @Field(() => Number)
  amount: number

  @Field(() => String)
  remarks?: string

  @Field(() => String)
  paymentStatus?: PaymentStatusEnum

  @Field(() => Date)
  date?: Date

  @Field(() => String)
  gatewayProvider?: PaymentGatewayProvider

  /**
   * Gateway idempotency key (forwarded as Stripe request options). Two concurrent refund calls
   * carrying the same key collapse into one refund at the gateway instead of double-refunding.
   */
  @Field(() => String)
  idempotencyKey?: string
}
export interface IRefundPayment extends IAction<PaymentRefund, RefundPaymentArgs> {}
